<template>
  <div class="register">
    <login-register>
			<register-form/>
		</login-register>
  </div>
</template>

<script>
import LoginRegister from '@/components/LoginRegister.vue'
import RegisterForm from '@/components/register/RegisterForm.vue'
export default {
	name: 'register',
	components: {
		LoginRegister,
		RegisterForm
	},
	created () {
		window.sessionStorage.removeItem('shiroSession')
	}
}
</script>

<style lang="stylus" scoped>
.register {
	display flex
	flex: 1
}
</style>
